import {
  Component,
  ElementRef,
  OnInit,
  ViewEncapsulation,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { SYDLEClientID } from "src/app/shared/constants/one-constants";
import { Dtm, getDtm } from "src/app/shared/enum/dtm";
import { Plan } from "src/app/shared/model/plan";
import { CatalogService } from "src/app/shared/services/catalog.service";
import { CustomerService } from "src/app/shared/services/customer.service";
import { DtmService } from "src/app/services/dtm.service";
import { SessionStorageService } from "src/app/shared/services/session-storage.service";
import { ShopWindowItem } from "../../../shared/model/shop-window-item";
import { ShopWindowMessage } from "../../../shared/model/shop-window-message";
import { DialogLoadingComponent } from "../../../shared/components/dialog-loading/dialog-loading.component";
import { LoadingComponent } from "src/app/shared/components/loading/loading.component";
import { MatDialog } from "@angular/material/dialog";
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";
import { DialogAlertComponent } from "src/app/shared/components/dialog-alert/dialog-alert.component";
import { DiscountModalService } from "src/app/shared/services/discount-modal.service";
import { DialogData } from "src/app/shared/model/dialog-data";
import { ShopWindowService } from "src/app/shared/services/shop-window.service";
import { ShopWindowManager } from "src/app/shared/model/shop-window-manager";
import { HeaderContent } from "src/app/shared/model/headerContent";
import { NutritionTable } from "src/app/shared/model/nutrition-table";
import { packageSuggestionModalDisplayLogService } from "src/app/shared/services/packageSuggestionModalDisplayLog.service";

const PLAN_CLASSIFICATION = "descomplica";

@Component({
    selector: "pme-descomplica-shop-window",
    templateUrl: "./descomplica-shop-window.component.html",
    styleUrls: ["./descomplica-shop-window.component.scss"],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class DescomplicaShopWindowComponent implements OnInit {
  //Variáveis de conteúdo do Shop Window
  headerContent: HeaderContent;
  tableNutritionContent: NutritionTable;
  packages: Array<ShopWindowItem> = [];
  plans: Array<ShopWindowItem> = [];
  selectedPlan: ShopWindowItem;

  // Variáveis de query params
  coupon: any;
  userId: any;
  businessId: any;
  ref: string;
  internalReference: any;
  checksum: any;
  checksumData: { ref: any; internalReference: any; cs: any };

  // Controle do Switch
  selectedToggle: number = 0;

  classificationsGetted: number = 0;
  purchaseOrigin: string;
  submitting: boolean;
  sugestionModalDataProducts: any;
  openModalSuggestionFlag: any;

  stackingOnePackage: boolean;

  periodicity: Array<string> = [];
  plansByPeriodicty: { [key: string]: Array<ShopWindowItem> } = {};
  periodicityList: Array<string> = [];
  currentPlans: Array<ShopWindowItem> = [];

  constructor(
    public catalogService: CatalogService,
    public packageSuggestionModalDisplayLogService: packageSuggestionModalDisplayLogService,
    private customerService: CustomerService,
    private route: ActivatedRoute,
    private router: Router,
    private sessionStorageService: SessionStorageService,
    public dtmService: DtmService,
    public dialog: MatDialog,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private discountModalService: DiscountModalService,
    private elementRef: ElementRef,
    private shopWindowService: ShopWindowService
  ) {
    this.openDialogSpinner();
    if (!this.sessionStorageService.isReloading()) {
      localStorage.removeItem("checkoutSuccessData");
      this.sessionStorageService.resetSessionStorage();
    }
    this.sessionStorageService.clearSessionStorage([
      "category",
      "product",
      "identificacaoCompleted",
      "pagamentoCompleted",
      "sucessoCompleted",
      "name",
      "email",
      "cart",
      "customer",
    ]);

    this.getParameters();
    const validatedMitigation = this.sessionStorageService.getValidatedMitigation();
    this.catalogService
      .getProductsByClassification(
        PLAN_CLASSIFICATION,
        this.userId,
        validatedMitigation,
        this.coupon,
        this.businessId,
        this.checksumData
      )
      .subscribe((shopWindow) => {
        this.sessionStorageService.setValidatedMitigation(
          shopWindow.validatedMitigation
        );

        this.plans = shopWindow.shopWindowItems;

        this.getPlansByPeriodicity();

        this.dtmService.productsLoaded(
          this.plans.map((plan) => ({
            classificationName: plan.product.classificationName,
            identifier: plan.product.identifier,
            value: plan.totalValue
          }))
        );

        this.closeDialogSpinner();

        this.dtmService.customLoaded([]);
        this.dtmService.pageLoaded(
          Dtm.MeuPlano,
          false,
          getDtm(Dtm.MeuPlano, PLAN_CLASSIFICATION)
        );
        this.dtmService.sendPageLoadEvent();
        this.dtmService.customLoaded(["ProdImpression", "OverlayImpression"]);
        this.dtmService.ruleChange("ProdImpression");

        this.dtmService.sendPageLoadEvent("ProdImpression");
      }),
      (error) => {
        this.handleRequestError("getProductCatalogByCategory", error);
      },
      () => {};
    this.loadShopWindowContent();
    this.closeDialogSpinner();
  }

  openDialogSpinner(): void {
    this.closeDialogSpinner();
    this.dialog.open(LoadingComponent, {
      disableClose: true,
      width: '400px',
      panelClass: 'pme-dialog-loading-panel',
      backdropClass: 'pme-dialog-loading-backdrop'
    });
  }

  getPlansByPeriodicity() {
    this.plansByPeriodicty = this.plans.reduce((acc, plan) => {
      const periodicity = plan.product.periodicity;
      if (!acc[periodicity]) {
        acc[periodicity] = [];
      }
      acc[periodicity].push(plan);
      return acc;
    }, {});

    this.periodicityList = Object.keys(this.plansByPeriodicty);

    this.onSelectionChanged(0);
  }

  /** Abre dialog em caso de erro durante a venda deslogada */
  openErrorDialog(dialogData, productIdentifier) {
    const data = DialogData.fromPreset(dialogData);
    const content = data.errorMessage;
    const errorDetail = data.errorDetail;

    this.dialog.open(DialogAlertComponent, {
      disableClose: true,
      panelClass: "pme-dialog-alert-panel",
      autoFocus: false,
      data: data,
    });

    // Analytics
    this.dtmService.customErrorLoaded(["error"], {
      errorDetail: errorDetail || productIdentifier,
      errorMessage: content,
    });
  }

  getParameters() {
    this.getProvisioningParametersFromSessionStorage();

    this.route.queryParams.subscribe((params) => {
      this.coupon = params.coupon;
      if (this.coupon) {
        sessionStorage.setItem("coupon", this.coupon);
      }
      if (params.userId && params.businessId) {
        this.userId = params.userId;
        this.businessId = params.businessId;
        this.setProvisioningParametersOnSessionStorage();
      }

      if (params.redirectUrl) {
        sessionStorage.setItem("successRedirectUrl", params.redirectUrl);
      }

      // Obtem parametros de checksum
      if (params.cs) {
        if (params.ref) {
          try {
            // Obtem user e business id do parametro ref em base64
            this.ref = atob(params.ref);
            const [refUserId, refBusinessId] = this.ref.split(":");

            if (refUserId) {
              this.userId = refUserId;
            }
            if (refBusinessId) {
              this.businessId = refBusinessId;
            }
            this.setProvisioningParametersOnSessionStorage();
          } catch (err) {}
        }

        if (params.internalReference) {
          this.internalReference = params.internalReference;
        }

        this.checksum = params.cs;
        this.checksumData = {
          ref: this.ref,
          internalReference: this.internalReference,
          cs: this.checksum,
        };

        // Remove query params
        this.router.navigate([], {
          queryParams: {
            cs: null,
            ref: null,
            internalReference: null,
          },
          queryParamsHandling: "merge",
        });
      }
    });
  }

  private closeDialogSpinner() {
    this.dialog.closeAll();
  }

  handleRequestError(request: string, err: any) {
    let errJson = err.error;
    try {
      if (typeof errJson === "string") {
        errJson = JSON.parse(errJson);
      }
    } catch (e) {}

    let errorDetail = errJson.generalMessages.map(
      (errorMessage: any) => errorMessage.text
    );

    if (errorDetail.includes("SHOP_WINDOW_BLOCKED_USER")) {
      this.openErrorDialog("mitigated", "meu-plano");
    } else {
      this.dtmService.customErrorLoaded(["error"], {
        errorDetail: JSON.stringify(errorDetail),
        errorMessage:
          "Não foi possível buscar os catálogo de produtos. Tente novamente mais tarde",
      });
    }
  }

  getProvisioningParametersFromSessionStorage() {
    this.userId = this.sessionStorageService.getUserId();
    this.businessId = this.sessionStorageService.getBusinessId();

    this.dtmService.userLoaded({
      userId: this.userId,
      businessId: this.businessId,
      clientId: SYDLEClientID,
    });

    if (!this.userId || !this.businessId) {
      this.sessionStorageService.setIsLogged(false);
    } else {
      this.sessionStorageService.setIsLogged(true);
    }
  }

  setProvisioningParametersOnSessionStorage() {
    this.sessionStorageService.setUserIdAndBusinessId(
      this.userId,
      this.businessId
    );
    this.dtmService.userLoaded({
      userId: this.userId,
      businessId: this.businessId,
      clientId: SYDLEClientID,
    });

    if (this.userId && this.businessId) {
      this.sessionStorageService.setIsLogged(true);
    }
  }

  loadShopWindowContent() {
    this.shopWindowService
      .getShopWindow(PLAN_CLASSIFICATION)
      .subscribe((shopWindow: any) => {
        let shopWindowManager = new ShopWindowManager(shopWindow);
        this.headerContent = shopWindowManager.header;
        this.tableNutritionContent = shopWindowManager.nutritionTable;
      });
  }

  onSelectionChanged(selectedIndex: number) {
    this.selectedToggle = selectedIndex;
    this.currentPlans =
      this.plansByPeriodicty[this.periodicityList[selectedIndex]] || [];
  }

  handlePlanClick(i: number, autoClicked = false) {
    const currPlan = this.currentPlans;
    const selectedPlan = currPlan[i] ? currPlan[i] : null;

    if (!selectedPlan || selectedPlan?.disable) {
      const enableProducts = currPlan.filter((pckg) => !pckg.disable);
      this.openErrorDialog(
        "productDisabled",
        enableProducts
        //currPlan[i].product.identifier
      );
      this.sessionStorageService.setPurchaseOrigin("");
      return;
    }

    this.selectedPlan = selectedPlan;

    // Adobe Analytics
    if (!autoClicked) {
      this.discountModalService.setClickedOnPackages(true);
      this.dtmService.customLoaded(["ProdClick", "OverlayProdClick"]);
      this.dtmService.productsLoaded([
        {
          classificationName: selectedPlan.product.classificationName,
          identifier: selectedPlan.product.identifier,
          value: selectedPlan.totalValue
        },
      ]);
      window.setTimeout(() => "", 500);
      this.dtmService.ruleChange("prodClick");
      this.dtmService.sendPageLoadEvent("prodClick");
    }
  }

  navigate(i: number) {
    this.submitting = true;
    this.handlePlanClick(i);

    // Se existe uma targetURL no sessionStorage, usa-a pra navegar
    const targetUrl = sessionStorage.getItem("targetUrl");
    if (targetUrl && targetUrl !== "") {
      this.router.navigate([targetUrl]);
    } else {
      this.router.navigate(["../identificacao"], { relativeTo: this.route, queryParamsHandling: 'preserve' });
    }

    this.sessionStorageService.setProduct(this.selectedPlan.product.identifier);
    this.sessionStorageService.setClassification(this.selectedPlan.product.classificationIdentifier);
    this.sessionStorageService.setClassification(this.selectedPlan.product.classificationName);
  }

  ngOnInit(): void {}
}
